import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Client} from 'src/app/models/client.model';
import {IonSearchbar, ModalController} from '@ionic/angular';
import {VetClinic} from '../../models/vet-clinic.model';
import {ClientsService} from '../../providers/clients.service';
import {VetClinicService} from '../../providers/vet-clinic.service';
import {CommonUtils} from '../../utils/common';
import {AppStateService} from '../../providers/app-state.service';
import {Subscription} from 'rxjs';
import {
  VetineoVisitTypeCategory,
  VetineoVisitTypeCategorySearchObject
} from "../../models/vetineo-visit-type-category.model";


@Component({
  selector: 'app-item-finder',
  templateUrl: './item-finder.component.html',
  styleUrls: ['./item-finder.component.scss'],
})
export class ItemFinderComponent implements OnInit, OnDestroy {


  @Input()
  title: string;

  @Input()
  itemType: 'clients' | 'clinics' | 'categories';

  @Input()
  relatedItemUUID: string;

  @Input()
  nameToFind: string;

  @Input()
  partnersIncluded: boolean = false;

  @Input() vetineoVisitTypeCategories: VetineoVisitTypeCategory[];
  vetineoVisitTypeCategorySearchObjects: VetineoVisitTypeCategorySearchObject[];

  chosenItem: Client | VetClinic | VetineoVisitTypeCategorySearchObject | null = null;
  clientsSub: Subscription;
  clinicsSub: Subscription;
  isBusySub: Subscription;


  items: Client[] | VetClinic[] | VetineoVisitTypeCategorySearchObject[];
  @ViewChild('search') search: IonSearchbar;


  private isBusy: boolean;
  isLoading: boolean = false;

  constructor(private modalController: ModalController,
              private clientsService: ClientsService,
              private vetClinicService: VetClinicService,
              private commonUtils: CommonUtils,
              private appStateService: AppStateService) { }

  ngOnInit() {
    this.isBusySub= this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });

    if (this.itemType === 'categories') {

      this.vetineoVisitTypeCategorySearchObjects = [];
      for (const cat of this.vetineoVisitTypeCategories) {
        for (const subcat of cat.subcategories) {
          this.vetineoVisitTypeCategorySearchObjects.push({category: cat, subcategory: subcat});
        }
      }
    }
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }


  ionViewDidEnter() {
    if(this.search){
      this.search.setFocus();
    }
  }

  prepareFoundItems() {
    if (this.nameToFind.length >= 3) {
      console.log('Name to find', this.nameToFind);
      this.appStateService.updateIsBusySubject(true);
      if(this.itemType === 'clients') {
        this.isLoading =true;
        this.clientsSub = this.clientsService.searchForClientByPhrase(this.nameToFind, this.partnersIncluded).subscribe(clients => {
          if (clients) {
            console.log(clients);
            this.items = clients;
          }
          this.isLoading =false;
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.isLoading =false;
          switch (error.message) {
            case 'CLIENTS_NOT_FOUND':
              this.commonUtils.presentAlertToast('Nie znaleziono klientów');
              this.appStateService.updateIsBusySubject(false);
              break;
            default:
              this.commonUtils.presentAlertToast('Wystąpił błąd');
              this.appStateService.updateIsBusySubject(false);
          }
        });
      } else if (this.itemType === 'clinics') {
        this.isLoading =true;
        this.clinicsSub = this.vetClinicService.searchForClinicsByPhrase(this.relatedItemUUID, this.nameToFind).subscribe(clinics => {
          if (clinics) {
            this.items = clinics;
          }
          this.isLoading =false;
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.isLoading =false;
          switch (error.message) {
            case 'CLINICS_NOT_FOUND':
              this.commonUtils.presentAlertToast('Nie znaleziono lecznic');
              this.appStateService.updateIsBusySubject(false);
              break;
            default:
              this.commonUtils.presentAlertToast('Wystąpił błąd');
              this.appStateService.updateIsBusySubject(false);
          }
        });
      } else if (this.itemType === 'categories' && this.vetineoVisitTypeCategorySearchObjects) {

        this.isLoading = true;
        this.items = this.getMatchingCategorySearchObjects(this.nameToFind);
        this.isLoading =false;
        this.appStateService.updateIsBusySubject(false);
      }
    }

  }

  onItemChosen(item: Client | VetClinic | VetineoVisitTypeCategorySearchObject) {

    this.chosenItem = item;
    this.modalController.dismiss(this.chosenItem, 'confirm');
  }

  getItemName(item) {
    if(this.itemType === 'clients') {
      return item.name;
    }
    if(this.itemType === 'clinics') {
      return item.clinicName;
    }
    if (this.itemType === 'categories') {
      return `${item.subcategory.name} (${item.category.name})`;
    }

  }
  ngOnDestroy() {
    if (this.clientsSub) {
      this.clientsSub.unsubscribe();
    }
    if (this.clinicsSub) {
      this.clinicsSub.unsubscribe();
    }
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }

  }

  onFindByEnter() {
    if (this.items && this.items.length === 1) {
      this.onItemChosen(this.items[0]);
    }
  }

  private getMatchingCategorySearchObjects(nameToFind: string) {

    const matching: VetineoVisitTypeCategorySearchObject[] = [];
    for (const searchObj of this.vetineoVisitTypeCategorySearchObjects) {
      if (searchObj.subcategory.name.toLowerCase().includes(nameToFind.toLowerCase())) {
        matching.push(searchObj);
      }
    }
    return matching;
  }

  onEscape($event: KeyboardEvent) {
    if (this.nameToFind && this.nameToFind.length > 0) {
      this.nameToFind = '';
      $event.preventDefault();
      $event.stopPropagation();
      this.items = null;
    }

  }
}
